export const getPublicStorageBaseUrl = (): string =>
  (
    process.env.REACT_APP_PUBLIC_STORAGE_BASE_URL ||
    process.env.REACT_APP_STORAGE_BASE_URL ||
    ""
  ).replace(/\/$/, "");

export const publicAssetUrl = (assetPath: string): string => {
  const base = getPublicStorageBaseUrl();
  if (!base) return "";

  const normalizedPath = assetPath.replace(/^\//, "");
  return `${base}/${normalizedPath}`;
};

export const PUBLIC_UPLOADS_PREFIX = "public/uploads/";

export const getGenericMotoImageUrl = (): string =>
  publicAssetUrl(`${PUBLIC_UPLOADS_PREFIX}generic-moto.png`);
